import { baseUrl, DOWNLOAD_FILE } from "../../../shared/api/endpoints";

/** Invalid gallery IDs use the local avatar instead of requesting a broken URL. */
export function chatAvatarUrl(chat) {
  const id = [chat?.boothGalleryId, chat?.userGalleryId].map(Number)
    .find((value) => Number.isFinite(value) && value > 0);
  return id ? `${(baseUrl || "").replace(/\/+$/, "")}/${DOWNLOAD_FILE}/${id}?size=thumbnail` : null;
}
